import styled from 'styled-components';
import { Mixins, Spacing } from 'web-common/src/shared/styles';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  flex: 0 0 auto;
  gap: ${Spacing.SINGLE};
  max-width: 600px;

  ${Mixins.Media.maxWidthSmall(`
    gap: ${Spacing.HALF};
  `)}
`;
